// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDYsaZLKL64NC3CTLFNcgxuu2PCdRbs9KE",
  authDomain: "mple-production-v2.firebaseapp.com",
  projectId: "mple-production-v2",
  storageBucket: "mple-production-v2.firebasestorage.app",
  messagingSenderId: "1096153214594",
  appId: "1:1096153214594:web:b611802b9342e442ea8e9b",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// const messaging = getMessaging(firebaseApp);

// const analytics = getAnalytics(firebaseApp);
export { firebaseApp };
